import { useEffect, useMemo, useRef } from 'react';

export function useDebounce(callback, delay = 300) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  const timeoutRef = useRef(null);

  const debouncedFn = useMemo(
    () => (...args) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => cbRef.current(...args), delay);
    },
    [delay]
  );

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return debouncedFn;
}